import Lottie from 'lottie-react';
import appCompoLoading from '@/assets/animation/dog-walking.json';
import Logo from '@/assets/img/user-side-logo.svg';
import { useBusinesses } from '@/features/availability/api/getBusinesses';
import { useEffect, useState, ChangeEvent, useRef, useContext } from 'react';
import { Business, Service } from '@/features/availability/types';
import './PetStores.scss';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '@/assets/img/v2/search-icon.svg';
import { ReactComponent as AddressIcon } from '@/assets/img/v2/address-icon.svg';
import { ReactComponent as PhoneIcon } from '@/assets/img/v2/phone-icon.svg';

import { ReactComponent as LinkIcon } from '@/assets/img/v2/redirect-link.svg';

import { PetStoreCard } from '@/features/petStores/components/PetStoreCard';
import { Modal } from 'react-bootstrap';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import { BackNav } from '@/components/BackNavigation/BackNavigation';
import { showNotification } from '@/utils/notificationUtils';
import { UserContext } from '@/components/Layout';
import { useTranslation } from 'react-i18next';

export const PetStores = () => {
  const userContext = useContext(UserContext);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const [showBusinessModal, setShowBusinessModal] = useState<boolean>();
  const [selectedBusinessModal, setSelectedBusinessModal] = useState<Business>();

  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const perPage = 20;
  const [selectedPage, setSelectedPage] = useState(1);
  const useGetBusinessListMutation = useBusinesses();
  const [searchQuery, setSearchQuery] = useState<string>();
  const [businessList, setBusinessList] = useState<Business[]>();
  const { t } = useTranslation();

  useEffect(() => {
    fetchStores();
  }, [searchQuery]);
  const fetchStores = async (pageIndex = 1, reset = false) => {
    if (totalPages == 0 || pageIndex <= totalPages) {
      const res = await useGetBusinessListMutation.mutateAsync({
        page: pageIndex,
        perPage: perPage,
        search: searchQuery,
      });
      setSelectedPage(pageIndex);
      setTotalPages(res.totalPages);
      setTotalRecords(res.total);
      if (pageIndex == 1 || reset) {
        setBusinessList(res.list);
        if (reset) {
          window.scrollTo(0, 0);
        }
      } else {
        businessList && setBusinessList(businessList.concat(res.list));
      }
    }
  };
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const onStoreClick = (store: Business) => {
    window.scrollTo(0, 0);
    setShowBusinessModal(true);
    setSelectedBusinessModal(store);
  };
  const onStoreLinkClick = (store: Business) => {
    if (store.services && store.services.length > 0) {
      navigate(`/${store.slug}`, {
        state: store.id,
      });
    } else {
      showNotification({
        type: 'info',
        title: t("Selected store doesn't provide any services."),
      });
    }
  };
  const onBackToList = () => {
    setSelectedBusinessModal(undefined);
    setShowBusinessModal(false);
  };
  const fetchMoreOnBottomReached = (containerRefElement?: HTMLDivElement | null) => {
    if (containerRefElement) {
      const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
      if (scrollHeight - scrollTop - clientHeight < 50 && !useGetBusinessListMutation.isLoading) {
        fetchStores(selectedPage + 1);
      }
    }
  };
  const handlePageClick = async (event: any) => {
    fetchStores(event.selected + 1, true);
  };
  const showm = true;
  const startIndex = selectedPage == 1 ? 1 : (selectedPage - 1) * perPage + 1;
  const endIndex =
    selectedPage == 1
      ? 1 * perPage
      : selectedPage == totalPages
      ? totalRecords
      : selectedPage * perPage;

  const paginationText = `Showing ${startIndex} to ${endIndex} of ${totalRecords} entries`;
  return (
    <div className="petsked-container-no-bg">
      {(showm && userContext?.isLandscape) || (!userContext?.isLandscape && !showBusinessModal) ? (
        <div className="petsked-content pet-stores">
          <PetskedTitle
            title={t("Pick a store to start")}
            highlightTitle={t("booking")}
            size="lg"
            alignText="left"
            description=""
          />
          <div className="petsked-form search-box">
            <input
              value={searchQuery}
              id="search"
              onChange={handleChange}
              type="search"
              placeholder={t("Search shop name, address, services..")}
            />
            <SearchIcon />
          </div>
          <div
            className="stores"
            onScroll={(e) => fetchMoreOnBottomReached(e.target as HTMLDivElement)}
            ref={scrollContainerRef}
          >
            {businessList &&
              businessList.map((item, index) => {
                return (
                  <PetStoreCard
                    petStore={item}
                    onStoreLinkClick={onStoreLinkClick}
                    onStoreClick={onStoreClick}
                  />
                );
              })}
            <div className="gradient"></div>
            {totalPages > 1 && (
              <div className="paginate">
                <p className="description">{paginationText}</p>
                <div className="pagination-stores">
                  <ReactPaginate
                    nextLabel=""
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel=""
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item previous-button"
                    previousLinkClassName="page-link"
                    nextClassName="page-item next-button"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                  />
                </div>
              </div>
            )}
          </div>
          {userContext?.isLandscape && (
            <>
              <Modal
                className="petsked-modal-dialog petsked-business-modal"
                show={showBusinessModal ? true : false}
                onHide={() => setShowBusinessModal(undefined)}
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  <img className="business-image" src={selectedBusinessModal?.businessImageUrl} />
                  <h5>{selectedBusinessModal?.name}</h5>
                  <span className={`store-details ${selectedBusinessModal?.address ? '' : 'hide'}`}>
                    <AddressIcon />
                    <p className="link" title={selectedBusinessModal?.address}>
                      {selectedBusinessModal?.address}
                    </p>
                    <LinkIcon className="link" />
                  </span>
                  <span
                    className={`store-details last ${selectedBusinessModal?.phone ? '' : 'hide'}`}
                  >
                    <PhoneIcon />
                    <p title={selectedBusinessModal?.address}>{selectedBusinessModal?.phone}</p>
                  </span>
                  <label>{t('About us')}</label>
                  <p className="desc">
                    {selectedBusinessModal?.description
                      ? selectedBusinessModal?.description
                      : t(`Transform your pet's pampering experience at our grooming and pet care store, where
          expertise meets love.`)}
                  </p>
                  <label>{t('Services')}</label>
                  <ul className="services">
                    {selectedBusinessModal?.services &&
                      selectedBusinessModal?.services.map((service: Service, index: number) => (
                        <li className={`service-${index % 3}`}>{service.name}</li>
                      ))}
                  </ul>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    type="button"
                    onClick={() => selectedBusinessModal && onStoreLinkClick(selectedBusinessModal)}
                    className="petsked-button button-dark"
                  >
                    {t('Book Appointment')}
                  </button>{' '}
                </Modal.Footer>
              </Modal>
            </>
          )}

          {businessList && businessList.length == 0 && (
            <div className="valid-business">
              <Lottie className="h-80 w-80" animationData={appCompoLoading} />
              <div className="valid-url-text">{t('Enter valid business url')}</div>
            </div>
          )}
        </div>
      ) : (
        <div>
          {!userContext?.isLandscape && (
            <>
              <div className="petsked-business-modal mobile">
                <BackNav onClick={onBackToList} />
                <div className="content">
                  <img className="business-image" src={selectedBusinessModal?.businessImageUrl} />
                  <h5>{selectedBusinessModal?.name}</h5>
                  <span className={`store-details ${selectedBusinessModal?.address ? '' : 'hide'}`}>
                    <AddressIcon />
                    <p className="link" title={selectedBusinessModal?.address}>
                      {selectedBusinessModal?.address}
                    </p>
                    <LinkIcon className="link" />
                  </span>
                  <span
                    className={`store-details last ${selectedBusinessModal?.phone ? '' : 'hide'}`}
                  >
                    <PhoneIcon />
                    <p title={selectedBusinessModal?.address}>{selectedBusinessModal?.phone}</p>
                  </span>
                  <label>{t('About us')}</label>
                  <p className="desc">
                    {selectedBusinessModal?.description
                      ? selectedBusinessModal?.description
                      : t(`Transform your pet's pampering experience at our grooming and pet care store, where
          expertise meets love.`)}
                  </p>
                  <label>{t('Services')}</label>
                  <ul className="services">
                    {selectedBusinessModal?.services &&
                      selectedBusinessModal?.services.map((service: Service, index: number) => (
                        <li className={`service-${index % 3}`}>{service.name}</li>
                      ))}
                  </ul>
                  <hr />
                  <div className="action">
                    <button
                      type="button"
                      onClick={() =>
                        selectedBusinessModal && onStoreLinkClick(selectedBusinessModal)
                      }
                      className="petsked-button button-dark"
                    >
                      {t('Book Appointment')}
                    </button>{' '}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
